import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, IconButton, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { BackdropLoader, Icon, InputWithIcon, toast } from '@livable/saas-react-components';
import { useStore } from 'src/stores';
import { SimpleConfirmationModal } from 'src/components/shared/SimpleConfirmationModal';
import useStyles from './styles';
import { formatCouponAppliesTo, formatCouponDiscount, formatCouponDuration, formatCouponExpiration, getCouponProductFilterValues, getCouponStatus, getCouponStatusTagSx } from './couponsModel';
import { CouponsFilterMenu } from './CouponsFilterMenu';
import { CouponModal } from './CouponModal';
import { CouponRedemptionsModal } from './CouponRedemptionsModal';
const ROWS_PER_PAGE_OPTIONS = [10, 25, 50];
const DEFAULT_ROWS_PER_PAGE = 25;
const EMPTY_COUPONS = [];
export const CouponsTab = observer(() => {
  var _store$stripe$coupons, _store$stripe$product, _store$stripe$deleteC;
  const classes = useStyles();
  const store = useStore();
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchQuery = _useState2[0],
    setSearchQuery = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    page = _useState4[0],
    setPage = _useState4[1];
  const _useState5 = useState(DEFAULT_ROWS_PER_PAGE),
    _useState6 = _slicedToArray(_useState5, 2),
    rowsPerPage = _useState6[0],
    setRowsPerPage = _useState6[1];
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    filterScope = _useState8[0],
    setFilterScope = _useState8[1];
  const _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    filterStatus = _useState0[0],
    setFilterStatus = _useState0[1];
  const _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    filterProducts = _useState10[0],
    setFilterProducts = _useState10[1];
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    couponModalOpen = _useState12[0],
    setCouponModalOpen = _useState12[1];
  const _useState13 = useState('create'),
    _useState14 = _slicedToArray(_useState13, 2),
    couponModalMode = _useState14[0],
    setCouponModalMode = _useState14[1];
  const _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    couponToEdit = _useState16[0],
    setCouponToEdit = _useState16[1];
  const _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    couponToDelete = _useState18[0],
    setCouponToDelete = _useState18[1];
  const _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    couponToReview = _useState20[0],
    setCouponToReview = _useState20[1];
  useEffect(() => {
    if (!store.stripe.couponsListLoaded) {
      store.stripe.getCouponsAsync.run();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.stripe]);
  const coupons = (_store$stripe$coupons = store.stripe.couponsList) !== null && _store$stripe$coupons !== void 0 ? _store$stripe$coupons : EMPTY_COUPONS;
  const products = (_store$stripe$product = store.stripe.productList) !== null && _store$stripe$product !== void 0 ? _store$stripe$product : EMPTY_COUPONS;
  const rows = coupons.map(coupon => _objectSpread(_objectSpread({}, coupon), {}, {
    status: getCouponStatus(coupon)
  }));
  const searchLower = (searchQuery || '').trim().toLowerCase();
  const filteredBySearch = !searchLower ? rows : rows.filter(row => (row.name || '').toLowerCase().includes(searchLower) || (row.code || '').toLowerCase().includes(searchLower) || (row.scope || '').toLowerCase().includes(searchLower) || (row.status || '').toLowerCase().includes(searchLower) || formatCouponAppliesTo(row).toLowerCase().includes(searchLower));
  const hasColumnFilters = filterScope.length > 0 || filterStatus.length > 0 || filterProducts.length > 0;
  const filteredRows = !hasColumnFilters ? filteredBySearch : filteredBySearch.filter(row => {
    if (filterScope.length > 0 && !filterScope.includes(row.scope)) return false;
    if (filterStatus.length > 0 && !filterStatus.includes(row.status)) return false;
    if (filterProducts.length > 0) {
      const rowProducts = getCouponProductFilterValues(row);
      if (!filterProducts.some(product => rowProducts.includes(product))) return false;
    }
    return true;
  });
  const start = page * rowsPerPage;
  const paginatedRows = filteredRows.slice(start, start + rowsPerPage);
  const handleSearchChange = e => {
    setSearchQuery(e.target.value);
    setPage(0);
  };
  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = e => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };
  const openRedemptionsModal = coupon => setCouponToReview(coupon);
  const closeRedemptionsModal = () => setCouponToReview(null);
  const openCouponModal = function (mode) {
    let coupon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    setCouponModalMode(mode);
    setCouponToEdit(coupon);
    setCouponModalOpen(true);
  };
  const closeCouponModal = () => {
    setCouponModalOpen(false);
    setCouponToEdit(null);
  };
  const refetchCoupons = () => store.stripe.getCouponsAsync.run();

  /**
   * Resolves to false so the modal stays open when the request fails (asyncModel raises the toast).
   * `run()` resolves rather than throws on failure, so the async model's own error state decides.
   */
  const handleSaveCoupon = async payload => {
    const isEdit = couponModalMode === 'edit' && (couponToEdit === null || couponToEdit === void 0 ? void 0 : couponToEdit.id);
    const request = isEdit ? store.stripe.updateCouponAsync : store.stripe.createCouponAsync;
    await request.run(isEdit ? _objectSpread({
      id: couponToEdit.id
    }, payload) : payload);
    if (request.isError) return false;
    if (!isEdit) setPage(0);
    toast('success', {
      body: [isEdit ? 'Coupon updated' : 'Coupon created', payload.code]
    });
    await refetchCoupons();
    return true;
  };
  const createDeleteHandler = coupon => () => setCouponToDelete(coupon);
  const handleConfirmDelete = async _ref => {
    let action = _ref.action,
      objectToPassOver = _ref.objectToPassOver;
    if (action === 'cancel' || !(objectToPassOver !== null && objectToPassOver !== void 0 && objectToPassOver.id)) {
      setCouponToDelete(null);
      return;
    }
    await store.stripe.deleteCouponAsync.run({
      id: objectToPassOver.id
    });
    setCouponToDelete(null);
    if (store.stripe.deleteCouponAsync.isError) return;
    toast('success', {
      body: ['Coupon deleted', objectToPassOver.code]
    });
    await refetchCoupons();
  };
  const isListLoading = store.stripe.getCouponsAsync.inProgress;
  const isSubmitting = store.stripe.createCouponAsync.inProgress || store.stripe.updateCouponAsync.inProgress;
  const hasLoadError = !isListLoading && store.stripe.getCouponsAsync.isError;
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.subscriptionsRoot
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isListLoading
  }), /*#__PURE__*/React.createElement(Box, {
    className: classes.subscriptionsToolbar
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.subscriptionsToolbarLeft
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    size: "small",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    variant: "outlined",
    placeholder: "Search",
    fullWidth: true,
    value: searchQuery,
    onChange: handleSearchChange
  })), /*#__PURE__*/React.createElement(CouponsFilterMenu, {
    filterScope: filterScope,
    filterStatus: filterStatus,
    filterProducts: filterProducts,
    availableProducts: products,
    onScopeChange: v => {
      setFilterScope(v);
      setPage(0);
    },
    onStatusChange: v => {
      setFilterStatus(v);
      setPage(0);
    },
    onProductsChange: v => {
      setFilterProducts(v);
      setPage(0);
    },
    onApply: () => setPage(0)
  }), /*#__PURE__*/React.createElement(Chip, {
    size: "small",
    variant: "infoIcon",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    label: "Customer redemption is not live yet \u2014 coupons are applied by Ops for now"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }),
    onClick: () => openCouponModal('create')
  }, "New coupon")), /*#__PURE__*/React.createElement(Paper, {
    variant: "outlined",
    className: classes.couponsTablePaper
  }, hasLoadError ? /*#__PURE__*/React.createElement(Box, {
    className: classes.subscriptionsTableEmpty
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.couponsLoadError
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary"
  }, "Coupons could not be loaded."), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    size: "small",
    onClick: refetchCoupons
  }, "Try again"))) : filteredRows.length === 0 ? /*#__PURE__*/React.createElement(Box, {
    className: classes.subscriptionsTableEmpty
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary"
  }, searchLower || hasColumnFilters ? 'No coupons match your search and filters.' : 'No coupons yet.')) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableContainer, {
    className: classes.subscriptionsTableContainer
  }, /*#__PURE__*/React.createElement(Table, {
    stickyHeader: true,
    size: "small",
    "aria-label": "coupons table"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeadCell
  }, "Coupon name"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeadCell
  }, "Code"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeadCell
  }, "Discount"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeadCell
  }, "Duration"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeadCell
  }, "Scope"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeadCell
  }, "Applies to"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeadCell
  }, "Expires"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeadCell
  }, "Redeemed"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeadCell
  }, "Status"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeadCell,
    align: "center"
  }, "Actions"))), /*#__PURE__*/React.createElement(TableBody, null, paginatedRows.map(row => {
    var _row$redemptionsCount;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.id,
      hover: true,
      className: "".concat(classes.tableBodyRow, " ").concat(row.status === 'Expired' ? classes.couponRowExpired : '')
    }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      fontWeight: 600,
      color: "text.primary"
    }, row.name)), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Box, {
      component: "span",
      className: classes.couponCode
    }, row.code)), /*#__PURE__*/React.createElement(TableCell, null, formatCouponDiscount(row)), /*#__PURE__*/React.createElement(TableCell, null, formatCouponDuration(row)), /*#__PURE__*/React.createElement(TableCell, null, row.scope), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.couponAppliesToCell
    }, formatCouponAppliesTo(row)), /*#__PURE__*/React.createElement(TableCell, null, formatCouponExpiration(row)), /*#__PURE__*/React.createElement(TableCell, null, ((_row$redemptionsCount = row.redemptionsCount) !== null && _row$redemptionsCount !== void 0 ? _row$redemptionsCount : 0) > 0 ? /*#__PURE__*/React.createElement(Link, {
      component: "button",
      type: "button",
      underline: "always",
      className: classes.redemptionsLink,
      onClick: () => openRedemptionsModal(row)
    }, row.redemptionsCount) : 0), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Chip, {
      label: row.status,
      size: "small",
      sx: getCouponStatusTagSx(row.status)
    })), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.couponActionsCell,
      align: "center"
    }, /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Edit coupon",
      onClick: () => openCouponModal('edit', row)
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    })), /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Delete coupon",
      onClick: createDeleteHandler(row)
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "trash"
    }))));
  })))), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    count: filteredRows.length,
    page: page,
    onPageChange: handleChangePage,
    rowsPerPage: rowsPerPage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS,
    className: classes.tablePagination
  }))), /*#__PURE__*/React.createElement(CouponRedemptionsModal, {
    isOpen: !!couponToReview,
    coupon: couponToReview,
    onClose: closeRedemptionsModal
  }), /*#__PURE__*/React.createElement(CouponModal, {
    isOpen: couponModalOpen,
    onClose: closeCouponModal,
    mode: couponModalMode,
    coupon: couponToEdit,
    coupons: coupons,
    products: products,
    isSubmitting: isSubmitting,
    onSave: handleSaveCoupon
  }), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    headerText: "Delete coupon",
    bodyText: couponToDelete ? "Do you really want to delete \"".concat(couponToDelete.name, "\"? The code <b>").concat(couponToDelete.code, "</b> stops working immediately. Redemptions already applied to invoices are not reverted.") : 'Do you really want to delete this coupon?',
    externalIsOpen: !!couponToDelete,
    callBack: handleConfirmDelete,
    objectToPassOver: couponToDelete,
    customSubmitButtonName: "Delete",
    isLoading: (_store$stripe$deleteC = store.stripe.deleteCouponAsync) === null || _store$stripe$deleteC === void 0 ? void 0 : _store$stripe$deleteC.inProgress
  }));
});